import { jsx as _jsx } from "react/jsx-runtime";
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { MODULE_CONTENT_TYPE_ORDER } from '../../../modules/constants/ModuleContentType';
let cachedOptions;

function getOptions() {
  if (!cachedOptions) {
    cachedOptions = MODULE_CONTENT_TYPE_ORDER.map(value => ({
      text: unescapedText(`contentUtils.contentTypes.${value}`),
      value
    }));
  }

  return cachedOptions;
}

export default function ModuleContentTypeFilter({
  disabled,
  onChange,
  scrollable = true,
  value
}) {
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.contentTypes.title'),
    disabled: disabled,
    multi: true,
    name: "contentTypes",
    onChange: onChange,
    options: getOptions(),
    scrollable: scrollable,
    value: value
  });
}